export const createStringComparator = (getProp) => (a, b) => {
  const aProp = getProp(a);
  const bProp = getProp(b);

  return aProp.localeCompare(bProp);
};

